<dx-popup
    #glBatchDetail
    minWidth="150px"
    minHeight="150px"
    width="75%"
    height="70%"
    title="Batch Detail"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="closePopup()"
>
    <div *dxTemplate="let item of 'content'">
        <dx-box height="100%" width="100%" direction="col" class="gl-batch-summary-box">
            <dxi-item baseSize="auto">
                <dx-form width="100%" height="100%" [colCount]="3" [labelLocation]="defaultLabelLocation">
                    <dxi-item>
                        <dxo-label text="GL Accounts"></dxo-label>
                        <div *dxTemplate>
                            <app-multi-column-selector
                                [name]="'GL Accounts'"
                                [gridSource]="glAccounts"
                                [boxValue]="glAccountGridBoxValue"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 400 }"
                                [valueExpr]="'key'"
                                [displayExpr]="'displayText'"
                                [columnDef]="glAccountColumns"
                                [showClearButton]="true"
                                [placeholder]="' '"
                                (gridSelectionEvent)="onGLAccountSelection($event)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Refresh"
                                [icon]="iconRefresh"
                                (onClick)="onRefreshClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item itemType="empty" [colSpan]="3"></dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1">
                <dx-data-grid
                    height="100%"
                    [dataSource]="glBatchDetailItems"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                >
                    <dxi-column
                        dataField="postDate"
                        dataType="date"
                        [format]="dateFormat"
                        caption="Post Date"
                    ></dxi-column>
                    <dxi-column
                        dataField="docDate"
                        dataType="date"
                        [format]="dateFormat"
                        caption="Doc Date"
                    ></dxi-column>
                    <dxi-column caption="document Number" dataField="docNumber" dataType="string"></dxi-column>
                    <dxi-column caption="Description" dataField="description" dataType="string"></dxi-column>
                    <dxi-column
                        caption="Vendor/Owner Name"
                        dataField="vendorCustomerName"
                        dataType="string"
                    ></dxi-column>
                    <dxi-column caption="GL Account No" dataField="glAccountNumber" dataType="string"></dxi-column>
                    <dxi-column caption="Source Type" dataField="sourceType" dataType="string"></dxi-column>
                    <dxi-column
                        caption="Debit"
                        dataField="debitAmount"
                        dataType="number"
                        [format]="currencyFormat"
                        cellTemplate="hyperlinkTemplate"
                    ></dxi-column>
                    <dxi-column
                        caption="Credit"
                        dataField="creditAmount"
                        dataType="number"
                        [format]="currencyFormat"
                        cellTemplate="hyperlinkTemplate"
                    ></dxi-column>

                    <dxi-column caption="Sub Category" dataField="subcategory" dataType="string"></dxi-column>
                    <div *dxTemplate="let row of 'hyperlinkTemplate'">
                        <app-hyperlink-creator
                            *ngIf="row.value !== 0 && hasHyperlink(row.data)"
                            [displayText]="row.value | ccCurrency"
                            (onLinkClick)="onAmountClick(row.data)"
                        ></app-hyperlink-creator>
                        <span *ngIf="!hasHyperlink(row.data)">
                            {{ row.value | ccCurrency }}
                        </span>
                    </div>

                    <dxo-summary [calculateCustomSummary]="calculateCustomSummary">
                        <dxi-total-item
                            name="debitAmount"
                            showInColumn="debitAmount"
                            summaryType="custom"
                            dataType="number"
                            displayFormat="Total: {0}"
                            [valueFormat]="currencyFormat"
                        ></dxi-total-item>
                        <dxi-total-item
                            name="creditAmount"
                            showInColumn="creditAmount"
                            summaryType="custom"
                            dataType="number"
                            displayFormat="Total: {0}"
                            [valueFormat]="currencyFormat"
                        ></dxi-total-item>
                    </dxo-summary>
                </dx-data-grid>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#glBatchDetail' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
